import { POST } from './API';

const PATH_ROOT = 'U012';

export type A01Input = {
  user_id: string;
  signal?: AbortSignal;
};
export type A01Output = {
  user_id: string;
  lastname: string;
  firstname: string;
  lastname_kana: string;
  firstname_kana: string;
  phone1: string;
  mail: string;
};

export async function A01(input: A01Input, cancellation?: AbortSignal): Promise<A01Output> {
  return await POST(`${PATH_ROOT}/inquiry_info`, {
    user_id: input.user_id,
    signal: cancellation,
  });
}

export type A02Input = {
  user_id: string;
  firstName?: string;
  lastName?: string;
  firstNameKana?: string;
  lastNameKana?: string;
  mail?: string;
  inquiryType: string;
  inquiry: string;
  phone1: string;
};
export type A02Output = {
  status: string;
  count: number;
  msg: string;
};

export async function A02(input: A02Input, cancellation?: AbortSignal): Promise<A02Output> {
  return await POST(`${PATH_ROOT}/inquiry`, {
    user_id: input.user_id,
    firstname: input.firstName,
    lastname: input.lastName,
    firstname_kana: input.firstNameKana,
    lastname_kana: input.lastNameKana,
    mail: input.mail || '',
    inquiry: input.inquiry,
    inquiry_type: input.inquiryType,
    phone1: input.phone1,
    signal: cancellation,
  });
}
